/* Global UI click — the cockpit "target select" tick, on every button press.
   A short filtered-noise transient (not a tone), matching the cockpit's clickHi.
   Mutable + persisted; the topbar speaker toggle flips window.GooseSound. */
(function () {
  var AC, noise, muted = localStorage.getItem('goose-sound') === 'off';
  function ctx() { AC = AC || new (window.AudioContext || window.webkitAudioContext)(); if (AC.state === 'suspended') AC.resume(); return AC; }
  function nbuf(c) {
    if (noise) return noise;
    var len = Math.floor(c.sampleRate * 0.5), b = c.createBuffer(1, len, c.sampleRate), d = b.getChannelData(0);
    for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    noise = b; return b;
  }
  // rubber-dome press: a soft rounded "pock" (lowpassed noise + body) with a
  // faint clicky contact underneath — gives the neumorphic buttons a tactile give
  function tick() {
    if (muted) return;
    try {
      var c = ctx(), t = c.currentTime;
      // 1 · rubbery body — lowpassed noise with a soft (non-instant) attack
      var src = c.createBufferSource(); src.buffer = nbuf(c); src.playbackRate.value = 0.82 + Math.random() * 0.22;
      var lp = c.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 640; lp.Q.value = 0.7;
      var rg = c.createGain();
      rg.gain.setValueAtTime(0.0001, t);
      rg.gain.exponentialRampToValueAtTime(0.17, t + 0.006);   // soft give, not a snap
      rg.gain.exponentialRampToValueAtTime(0.0001, t + 0.052);
      src.connect(lp); lp.connect(rg); rg.connect(c.destination);
      src.start(t); src.stop(t + 0.075);
      // 2 · rounded dome thump
      var o = c.createOscillator(); o.type = 'triangle';
      o.frequency.setValueAtTime(205, t); o.frequency.exponentialRampToValueAtTime(135, t + 0.05);
      var og = c.createGain();
      og.gain.setValueAtTime(0.0001, t); og.gain.exponentialRampToValueAtTime(0.12, t + 0.006); og.gain.exponentialRampToValueAtTime(0.0001, t + 0.06);
      o.connect(og); og.connect(c.destination); o.start(t); o.stop(t + 0.08);
      // 3 · faint clicky contact beneath, a hair later + quieter (dampened)
      var t2 = t + 0.008;
      var s2 = c.createBufferSource(); s2.buffer = nbuf(c); s2.playbackRate.value = 0.95 + Math.random() * 0.1;
      var bp = c.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 2000; bp.Q.value = 0.9;
      var cg = c.createGain();
      cg.gain.setValueAtTime(0.0001, t2); cg.gain.exponentialRampToValueAtTime(0.035, t2 + 0.001); cg.gain.exponentialRampToValueAtTime(0.0001, t2 + 0.006);
      s2.connect(bp); bp.connect(cg); cg.connect(c.destination); s2.start(t2); s2.stop(t2 + 0.03);
    } catch (e) {}
  }
  // any interactive control: real buttons, role=button, tabs, nav items, links
  // styled as buttons, clickable cards/rows, checklist items, toggles
  var SEL = 'button, [role="button"], .tab, .nav-item, a.btn, .client-ships, .clickable, .nr-item, .check-item, .check-box, tr.clickable';
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest(SEL);
    if (!el || el.disabled) return;
    tick();
  }, true);

  window.GooseSound = {
    tick: tick,
    get muted() { return muted; },
    set: function (on) { muted = !on; localStorage.setItem('goose-sound', on ? 'on' : 'off'); window.dispatchEvent(new CustomEvent('goose-sound-change', { detail: on })); },
    toggle: function () { this.set(muted); return !muted; },
  };
})();
